<template>
  <v-expansion-panel v-if="hasPackages">
    <v-expansion-panel-content
      expand
      class="grey lighten-4 elevation-5"
    >
      <div slot="header" class="my-4">
        <v-layout>
          <v-flex xs6>
            <h3>{{ item.name }}.</h3>
            <span v-show="item.type !== 'Free' || item.type === 'FreeAffiliate'">Price: {{item.price}}</span><br/>
            <span>Usage Count: {{item.usageCount}}</span>
          </v-flex>
          <v-flex xs4 offset-xs1>
            <v-list-tile-action>
              <v-layout>
                <v-flex xs9 class="my-2" @click.stop="">
                  <v-switch
                    v-model="item.status"
                    @change="editPackage"
                    true-value="Enabled"
                    false-value="Disabled"
                    :label="item.status"
                    :disabled="!isWriteAvailable"
                  />
                </v-flex>
                <v-flex xs2 offset-xs1 class="my-0">
                  <td class="text-xs-center">
                    <v-tooltip bottom>
                      <v-btn
                        color="error"
                        editItems
                        fab flat
                        slot="activator"
                        @click.stop="deletePackage"
                        :disabled="!isWriteAvailable"
                      >
                        <v-icon color="error">delete</v-icon>
                      </v-btn>
                      <span>Delete</span>
                    </v-tooltip>
                  </td>
                </v-flex>
              </v-layout>
            </v-list-tile-action>
          </v-flex>
        </v-layout>
      </div>
      <v-card>
        <v-card-text>
          <v-layout row wrap>

            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs2>
                  <content-field
                    label="Name"
                    v-model="item.name"
                    @input="$v.item.name.$touch"
                    @blur="$v.item.name.$touch"
                    :error="$v.item.name"
                  />
                </v-flex>
                <v-flex xs2 offset-xs1>
                  <v-select
                    label="Package type"
                    :items="packagesType"
                    auto
                    v-model="item.type"
                    required
                  />
                </v-flex>
                <v-flex xs1 offset-xs1>
                  <content-field
                    label="Price"
                    v-show="item.type != 'Free' || item.type != 'FreeAffiliate'"
                    v-model="item.price"
                    @input="$v.item.price.$touch"
                    @blur="$v.item.price.$touch"
                    :error="$v.item.price"
                  />
                </v-flex>
                <v-flex xs1 offset-xs1>
                  <content-field
                    label="Message limit"
                    v-model="item.messagesLimit"
                    @input="$v.item.messagesLimit.$touch"
                    @blur="$v.item.messagesLimit.$touch"
                    :error="$v.item.messagesLimit"
                  />
                </v-flex>
                <v-flex xs1 offset-xs1>
                  <content-field
                    label="Package title"
                    v-model="item.title"
                  />
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12>

              <v-layout column mt-3>
                <h3>Email Templates</h3>
                <v-layout wrap>
                  <v-flex xs5>
                    <v-select
                      :items="registrationSuccesTemplatesList"
                      v-model="item.confirmationEmailTemplateName"
                      :error-messages="isValid($v.item.confirmationEmailTemplateName)"
                      label="Confirmation Template"
                      item-value="templateKey"
                      item-text="templateKey"
                    />
                    <v-select
                      :items="registrationFailtureTemplatesList"
                      v-model="item.failedPaymentEmailTemplateName"
                      :error-messages="isValid($v.item.failedPaymentEmailTemplateName)"
                      label="Failed Payment Template"
                      item-value="templateKey"
                      item-text="templateKey"
                    />
                    <v-select
                      :items="multipleTicketsSuccessBuyTemplatesList"
                      v-model="item.multiUserConfirmationEmailTemplateKey"
                      :error-messages="isValid($v.item.multiUserConfirmationEmailTemplateKey)"
                      label="Multiple user confirmation email template"
                      item-value="templateKey"
                      item-text="templateKey"
                    />
                    <v-select
                      :items="multipleTicketsFailedBuyTemplatesList"
                      v-model="item.multiUserFailedPaymentEmailTemplateKey"
                      label="Multiple user failed email template"
                      item-value="templateKey"
                      item-text="templateKey"
                    />
                  </v-flex>

                </v-layout>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs2 d-flex class="my-4">
                  <h3>Package type:</h3>
                </v-flex>
                <v-flex xs3 d-flex class="my-4">
                    <v-checkbox
                      v-model="item.isInvitationPackage"
                      label="Is invitation package"
                    />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs2 d-flex class="my-4">
                  <h3>Visibility:</h3>
                </v-flex>
                <v-flex xs3 d-flex class="my-4">
                  <v-radio-group
                    v-model="item.visibility"
                    :error="$v.item.visibility.$error"
                    class="py-0"
                    row>
                    <v-radio
                      label="Public"
                      value="Public"
                    />
                    <v-radio
                      label="Category"
                      value="Category"
                    />
                  </v-radio-group>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 v-if="isVisibilityPublic">
              <v-layout row wrap>
                <v-flex xs2 d-flex class="my-4">
                  <h3>Available attendee type:</h3>
                </v-flex>
                <v-flex xs3 d-flex class="my-4">
                  <v-checkbox
                    label="Buy"
                    value="Buy"
                    v-model="item.availableAttendeeType"
                  />
                  <v-checkbox
                    label="Sell"
                    value="Sell"
                    v-model="item.availableAttendeeType"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 class="my-4">
              <v-layout row wrap>
                <v-flex d-flex xs2>
                  <strong>List of bound categories:</strong>
                </v-flex>
                <v-layout row wrap v-if="hasBoundCategories">
                  <v-flex
                    v-for="(category) in item.categories"
                    :key="category.id"
                    d-flex
                    xs3
                  >
                    <v-icon>done</v-icon>
                    <b>{{category.name}}</b>
                  </v-flex>
                </v-layout>
                <v-flex d-flex xs3 v-else>
                  No bound categories to show.
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs2 offset-xs2>
                  <p><strong>Creation Date: </strong> <i> {{date(item.creationDate)}} </i></p>
                </v-flex>
                <v-flex xs2>
                  <p><strong> Update Date: </strong> <i> {{date(item.updateDate)}}</i></p>
                </v-flex>
                <v-flex xs3 offset-xs1 v-if="users.length">
                  <p><strong>Last Modified Admin username:</strong> <i> {{getAdminEmailByPackage(item)}}</i></p>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 v-if="predefinedActivity">
              <h3>Predefined activities </h3>
              <v-layout row wrap>
                <v-flex
                  fluid
                  xs6
                  v-for="(value, index) in packagePredefinedActivity"
                  :key="`predefined-activitie-${value.title}-${index}`"
                >
                  <v-checkbox
                    :label="value.title"
                    v-model="item.predefinedActivities[index]"
                    :true-value="value.id"
                    :error="$v.item.predefinedActivities.$error"
                  />
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs6 offset-xs3>
              <killer-feature
                ref="formKillerFeature"
                :data="item.killerFeatureDisplaySetting"
                :key="`killerFeatureDisplaySetting-${packageIndex}`"
              />
            </v-flex>
            <v-flex xs12>
              <v-btn color="blue darken-1"
                     flat="flat"
                     :disabled="!isWriteAvailable || disabledButton"
                     @click.native="editPackage"
              >
                Save
              </v-btn>
              <v-btn
                color="blue darken-1"
                flat="flat"
                :disabled="disabledButton"
                @click.native="resetPackage"
              >
                Reset
              </v-btn>
            </v-flex>
            <small v-if="isRequiredMessage">*indicates required field</small>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { numeric, required, minValue } from 'vuelidate/lib/validators'
  import { merge, clone, path, isNil, intersection, pathOr } from 'ramda'
  import mixins from '@/utils/mixins'
  import KillerFeature from './killerFeature.vue'

  const defaultItem = {
    name: '',
    title: '',
    price: 100,
    type: 'Paid',
    visibility: 'Public',
    isInvitationPackage: false,
    status: 'Enabled',
    messagesLimit: 60,
    confirmationEmailTemplateName: '',
    failedPaymentEmailTemplateName: '',
    availableAttendeeType: [],
    predefinedActivities: [],
    killerFeatureDisplaySetting: null,
    multiUserFailedPaymentEmailTemplateKey: '',
    multiUserConfirmationEmailTemplateKey: ''
  }

  const validationTemplate = {
    name: { required },
    // subtitle: { required },
    price: { numeric, minValue: minValue(1)},
    type: { required },
    visibility: { required },
    confirmationEmailTemplateName: { required },
    failedPaymentEmailTemplateName: { required },
    predefinedActivities: { required },
    messagesLimit: { required, numeric },
    multiUserConfirmationEmailTemplateKey: { required }
  }

  export default {
    name: 'Packages',
    mixins: [mixins.isWriteAvailable, mixins.emailTemplates],
    components: {
      KillerFeature
    },
    props: {
      hasPackages: {
        type: Boolean,
        default: false
      },
      packageData: {
        type: Object,
        required: true,
        default: () => ({})
      },
      packageIndex: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        defaultItem,
        item: null,
        isRequiredMessage: false,
        disabledButton: false,
        packagesType: ['Free', 'Paid', 'PendingPaid', 'Contract', 'Affiliate', 'FreeAffiliate'],
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'registration:write'
      }
    },
    validations () {
      return {
        item: {
          ...validationTemplate
        }
      }
    },
    computed: {
      ...mapGetters({
        users: 'getUsersListWithCurrentUser',
        predefinedActivity: 'predefinedActivity'
      }),
      isVisibilityPublic () {
        return path(['visibility'], this.item) === 'Public'
      },
      hasBoundCategories () {
        return !!(!isNil(this.item.categories) &&  path(['categories', 'length'], this.item))
      },
      packagePredefinedActivity () {
        return this.predefinedActivity.filter((activity) => activity.activityDisplayLocation.indexOf('Package')!== -1)
      }
    },
    methods: {
      ...mapActions([
        'editPackageList',
        'deletePackageList',
        'showResultSuccessMessage',
        'showResultErrorMessage',
        'fetchUsers'
      ]),
      isValid (validationItem) {
        return validationItem.$dirty && validationItem.$invalid
          ? ['This field is required']
          : []
      },
      constructPackage () {
        if (Object.keys(this.packageData).length > 0) {
          if(this.packageData.availableAttendeeType.length > 0) {
            this.packageData.availableAttendeeType = this.packageData.availableAttendeeType.split(', ')
          }
          this.resetPackage()
        }
      },
      resetPackage () {
        this.item = clone(merge(this.defaultItem, this.packageData))
        this.item.predefinedActivities = this.packagePredefinedActivity.map(a => this.item.predefinedActivities.indexOf(a.id) > -1 ? true : false)
        console.log(this.item)
      },
      editPackage () {
        if (this.item.type === 'Free' || this.item.type === 'FreeAffiliate') {
          this.item.price = null
        }
        const killerFeatureDisplaySetting = this.$refs.formKillerFeature.submitForm()
        this.$v.item.$touch()
        if (this.$v.item.$invalid) return
        this.preEditPackages(killerFeatureDisplaySetting)
      },
      async preEditPackages (killerFeatureDisplaySetting) {
        this.disabledButton = true
        try {
          const item = merge(this.item, { killerFeatureDisplaySetting })
          item.predefinedActivities = item.predefinedActivities.map((v, i) => v ? this.packagePredefinedActivity[i].id : null).filter(i => i)
          if (this.isVisibilityPublic) {
            item.availableAttendeeType = typeof(item.availableAttendeeType) === 'string' ? item.availableAttendeeType : item.availableAttendeeType.join(', ')
          }
          await this.submitPackage(item)
        } catch (err) {
          const error = pathOr({}, ['response', 'data'], err)
          if (error.Code === 'validation.base-0001') {
            const pattern = RegExp('PackageEmailTemplateKeysValidatorBase-00(2|3|4)')
            const emailTemaplatenotChosenErr = error.ValidationFailures.filter(failure => pattern.test(failure.errorCode))
            emailTemaplatenotChosenErr.length ? this.showResultErrorMessage('Missing email template for listing. Either pick it or deselect corresponding activity(-ies)') : this.showResultErrorMessage('Validation error occured. Package wasn\'t saved')
          }
          throw err
        } finally {
          this.disabledButton = false
        }
      },
      async submitPackage (item) {
        try {
          console.log('submitPackage')
          await this.editPackageList(item)
          this.$emit('successSendPackage')
          this.showResultSuccessMessage('Package edit successful')
        } catch (err) {
          throw err
        }
      },
      async deletePackage () {
        if (this.item.categories.length) return this.showResultErrorMessage('Impossible to delete package assigned to Category. Please unassign Package from Category before deleting')
        try {
          await this.deletePackageList(this.item.id)
          this.$emit('successSendPackage')
          this.showResultSuccessMessage('Package delete successful')
        } catch (err) {
          this.showResultErrorMessage(err)
        }
      },
      date (date) {
        const d = new Date(date)
        const month = d.getMonth() + 1
        const day = d.getDate()
        const year = d.getUTCFullYear()
        return `${month} / ${day} / ${year}`
      },
      getAdminEmailByPackage (packageItem) {
        if (packageItem.hasOwnProperty('lastModifiedAdminId')) {
          const adminThatDidEditLast = this.users.find(user => user.id === packageItem.lastModifiedAdminId)
          return adminThatDidEditLast ? adminThatDidEditLast.userName : ''
        }
        return ''
      }
    },
    created () {
      this.constructPackage()
      this.fetchUsers()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Packages/package.vue